/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S3_P1Inputs */

const en_guide_what_is_json_s3_p1 = /** @type {(inputs: Guide_What_Is_Json_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before JSON, XML was the dominant data interchange format. However, JSON's simplicity and smaller file size made it a natural fit for web APIs. A typical JSON response is 30-50% smaller than an equivalent XML response, which means faster data transfer and lower bandwidth costs.`)
};

const ko_guide_what_is_json_s3_p1 = /** @type {(inputs: Guide_What_Is_Json_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 이전에는 XML이 지배적인 데이터 교환 포맷이었습니다. 그러나 JSON의 단순함과 작은 파일 크기로 인해 웹 API에 자연스럽게 적합했습니다. 일반적인 JSON 응답은 동등한 XML 응답보다 30-50% 작아 더 빠른 데이터 전송과 낮은 대역폭 비용을 의미합니다.`)
};

const ja_guide_what_is_json_s3_p1 = /** @type {(inputs: Guide_What_Is_Json_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON以前は、XMLが主要なデータ交換フォーマットでした。しかし、JSONのシンプルさとファイルサイズの小ささが、Web APIに自然にフィットしました。一般的なJSONレスポンスは同等のXMLレスポンスより30〜50%小さく、より高速なデータ転送と低い帯域幅コストを実現します。`)
};

/**
* | output |
* | --- |
* | "Before JSON, XML was the dominant data interchange format. However, JSON's simplicity and smaller file size made it a natural fit for web APIs. A typical JSO..." |
*
* @param {Guide_What_Is_Json_S3_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s3_p1 = /** @type {((inputs?: Guide_What_Is_Json_S3_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S3_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s3_p1(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s3_p1(inputs)
	return ja_guide_what_is_json_s3_p1(inputs)
});